module.exports = __webpack_public_path__ + "static/aboutBG-8346e09a65d228261c97bb0ef727c8a6.jpg";